import React, { useState } from "react";
import { BoxButton, CDialog, Icon } from "shared";
import { Send } from "assets";
import { useTranslation } from "react-i18next";
import InvitePatientForm from "routes/patientSearch/components/InvitePatient/InvitePatientForm";
import type { Country } from "utils/market";

interface Props {
  therapistId: number;
  country: Country;
}

const InvitePatient: React.VFC<Props> = ({ therapistId, country }) => {
  const [isOpen, setOpen] = useState(false);
  const { t } = useTranslation();

  const closeDialog = () => setOpen(false);
  const openDialog = () => setOpen(true);

  return (
    <>
      <BoxButton startIcon={<Icon of={Send} />} onClick={openDialog}>
        {t("patients.invite_a_patient")}
      </BoxButton>

      <CDialog maxWidth="xs" fullWidth open={isOpen} onClose={closeDialog} aria-labelledby="invite-patient">
        <InvitePatientForm onClose={closeDialog} therapistId={therapistId} defaultCountry={country} />
      </CDialog>
    </>
  );
};

export default InvitePatient;
